<template>

	<div class="row">

		<div class="col-md-12">
			<student-water />
		</div>

		<div class="col-md-12">
			<student-meals />
		</div>

	</div>

</template>

<script>

	import Alimentation from './';
	export default Alimentation;

</script>



// WEBPACK FOOTER //
// alimentation.vue?edbd030e